import { useState } from "react"
import { CardFiled, CardsContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { ICardFieldPanelProps } from "./CardFieldPanel"
import CardsFieldsFilterPanel from "./CardsFieldsFilterPanel"
import SingleCardField from "./SingleCardField"
import { Callout } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"

const CardsFieldsPanelContent = ( props: ICardFieldPanelProps ): JSX.Element => {

    // const data = props.data || {}
    const data: CardsContent  = useLandingStore((state: ILandingStore) => state.currentCardEdit)
    const [value,]  = useState<any[]>( data?.cards[0].value || [] ) 
    if(!data) {
        return <div className="container  mx-2 width-auto">            
            <Callout className="p-4 my-3 letter-spacing-1 row width-auto">
                <div className="small col-12">
                    {__("No cards selected")}
                </div>
                <div className="micro mt-2 col-12">
                    {__("Select some meat with cards")}
                </div>
            </Callout>
        </div>
    }
    const card_fields: CardFiled[] = data.card_fields || []
    const order: string[] = data.order || []

    // console.log( data.card_fields, data.cards )
    const compareByOrder = (a : CardFiled, b : CardFiled) => {
        let sa = order.findIndex( n => n === a.type )
        let sb = order.findIndex( n => n === b.type )
        sa = sa < 0 ? 1000 : sa
        sb = sb < 0 ? 1000 : sb

        if(sa > sb) {
            return 1
        }
        else if( sa < sb ) {
            return -1
        }
        return 0; 
    }
    const onClick = () => {
        useLandingStore.setState({ selectedCardField : null })
    }
    
    return <div className='landing-edit-layer' onClick={onClick}>
        <CardsFieldsFilterPanel  />
        <div className="panel-list overflow-y-auto">
            {
                card_fields.map((cf, i) => ({ ...cf, num: i}))
                //.sort( compareByOrder )
                .map(( cf, i ) => { 
                    return <SingleCardField cf={cf} order={order} key={ cf.type } />
                })
            }
        </div>
    </div> 
}

export default CardsFieldsPanelContent